module.exports = __webpack_public_path__ + "static/media/can2x.378323d2.png";